<fullscreen-page>
  <content-column look="light">
    <div slot="content" class="d-flex flex-column h-100 p-2">
      <dx-data-grid
        id='manufacturerGrid'
        class="flex-grow-1 overflow-hidden"
        [dataSource]="catalogManufaturerNames"
        [showBorders]="true"
        [allowColumnReordering]="true"
        [repaintChangesOnly]="true"
        [rowAlternationEnabled]="true"
        [allowColumnResizing]="true"
        [height]="'100%'"
      >
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-search-panel [visible]="true" [width]="240" placeholder="Suche …"></dxo-search-panel>
        <dxo-search enabled="true"></dxo-search>
        <dxi-column caption="{{ 'Im Katalog' | translate }}" dataField="manufacturerName"></dxi-column>
        <dxi-column caption="{{ 'Datenquelle' | translate }}" cellTemplate="dataSourceDropDownTemplate">
          <div *dxTemplate="let cell of 'dataSourceDropDownTemplate'">
            <dx-select-box
              [dataSource]="customerProductDataSources"
              [displayExpr]="displayCustomerSource"
              valueExpr="id"
              [(value)]="cell.data.currentId"
              [searchEnabled]="true"
              [dropDownOptions]="dropDownCfg"
              (onValueChanged)="changeDataSource(cell.data, $event.value)"/>
          </div>
        </dxi-column>
      </dx-data-grid>
      <dx-load-panel
        [visible]="isLoading"
        [showIndicator]="true"
        [shading]="false"
        [focusStateEnabled]="false"
        [position]="{ of: '#manufacturerGrid' }"
      ></dx-load-panel>
      <div class="d-flex justify-content-end mt-2">
        <dx-button text="Anwenden" type="default" stylingMode="contained" (onClick)="apply()"></dx-button>
      </div>
    </div>
  </content-column>
  <app-edit-datasource
    [(visible)]="popupVisible"
    [editMode]="false"
    [dataSource]="newAddedDatasource"
    [types]="types"
    [countryCodes]="countryCodes"
    (saved)="onEditSaved($event)"
  ></app-edit-datasource>
</fullscreen-page>
